/** Queue depth, and the button that drains it now instead of on the next tick. */

import { useToast } from '@/shared/components/toast'
import { usePipelineStatus, useRunPipeline } from '../hooks'

export function PipelineBadge({ graphId }: { graphId: string }) {
  const status = usePipelineStatus(graphId)
  const run = useRunPipeline(graphId)
  const toast = useToast()

  const queues = status.data?.queues ?? {}
  const pending = Object.values(queues).reduce((sum, n) => sum + n, 0)

  return (
    <div className="row-tight" style={{ marginLeft: 6 }}>
      <span
        className="queuepill"
        data-busy={pending > 0}
        title={Object.entries(queues)
          .map(([q, n]) => `${q}: ${n}`)
          .join('\n')}
      >
        {pending > 0 ? `${pending} queued` : 'idle'}
      </span>
      <button
        className="btn btn-sm"
        disabled={run.isPending}
        onClick={async () => {
          try {
            const result = (await run.mutateAsync()) as { counts?: Record<string, { handled: number }> }
            const handled = Object.values(result.counts ?? {}).reduce(
              (sum, c) => sum + (c?.handled ?? 0),
              0,
            )
            toast.success(
              handled
                ? `Processed ${handled} message${handled === 1 ? '' : 's'}.`
                : 'Nothing queued.',
            )
          } catch (error) {
            toast.error(error)
          }
        }}
      >
        {run.isPending ? 'Running…' : 'Run'}
      </button>
    </div>
  )
}
